import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink } from "lucide-react";
import usePageTitle from "@/lib/usePageTitle";

const Links = () => {
  usePageTitle("Helpful Links");
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/links").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const grouped = items.reduce((acc, l) => {
    (acc[l.category] = acc[l.category] || []).push(l);
    return acc;
  }, {});

  return (
    <div className="container-le section-pad" data-testid="links-page">
      <div className="max-w-2xl mb-12">
        <div className="text-xs uppercase tracking-[0.25em] text-secondary mb-3">Resources</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight">Helpful Links</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          Other organizations, agencies, and resources serving Lake Eunice Township residents.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {Object.keys(grouped).map((cat) => (
          <div key={cat}>
            <div className="text-xs uppercase tracking-[0.2em] text-accent mb-4">{cat}</div>
            <ul className="space-y-3">
              {grouped[cat].map((l) => (
                <li key={l.id} data-testid={`link-${l.id}`}>
                  <a
                    href={l.url}
                    target="_blank"
                    rel="noreferrer"
                    className="group flex items-center gap-2 text-foreground/90 hover:text-primary"
                  >
                    <span className="link-underline">{l.label}</span>
                    <ExternalLink size={13} className="opacity-50 group-hover:opacity-100" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Links;
